import React, { useState } from 'react';
import { FILTER_QUERY_BUILDER_TABS } from '_constants/old/filters';
import { QueryBuilderContainer } from 'modules/Modals/old/FilterModal/components/QueryBuilderContainer';
import { IsVaAccount, HasAccess, IsAzAccount } from 'modules';
import Location from 'modules/Modals/FilterPages/Location';
import { PERMISSIONS } from '_constants';
import VisitsHistory from '../DirectionsBuilderSections/VisitsHistory';
import RetailerCharacteristics from '../DirectionsBuilderSections/RetailerCharacteristics';
import * as Styled from './styles';

const TABS = [
  {
    id: 1,
    title: FILTER_QUERY_BUILDER_TABS.LOCATION,
  },
  {
    id: 2,
    title: FILTER_QUERY_BUILDER_TABS.RETAILER_CHARACTERISTICS,
  },
  {
    id: 3,
    title: FILTER_QUERY_BUILDER_TABS.VISITS_HISTORY,
  },
];

export const DirectionsQueryBuilder = () => {
  const [activeTab, setActiveTab] = useState(null);
  const isVaAccount = IsVaAccount();
  const isAzAccount = IsAzAccount();
  const hasResidentialModule = HasAccess(PERMISSIONS.RESIDENTIAL_LOCATION);

  const displayContent = () => {
    switch (activeTab) {
      case FILTER_QUERY_BUILDER_TABS.LOCATION:
        return <Location />;
      case FILTER_QUERY_BUILDER_TABS.RETAILER_CHARACTERISTICS:
        return (
          <RetailerCharacteristics
            isAzAccount={isAzAccount}
            isVaAccount={isVaAccount}
            isResidential={hasResidentialModule}
          />
        );
      case FILTER_QUERY_BUILDER_TABS.VISITS_HISTORY:
        return <VisitsHistory />;
      default:
        return null;
    }
  };

  return (
    <Styled.Wrapper>
      <QueryBuilderContainer tabs={TABS} id="wrapper" activeTab={activeTab} setActiveTab={setActiveTab}>
        {displayContent()}
      </QueryBuilderContainer>
    </Styled.Wrapper>
  );
};
